// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/californian-fb-3.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Californian FB";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

:root {
    --gold-color: #E9C455;
}

.material-symbols-rounded {
  font-variation-settings:
  'FILL' 1,
  'wght' 400,
  'GRAD' 200,
  'opsz' 24;
  font-size: 100px;
}

html, body {
    margin: 0px;
}

html {
    scroll-behavior: smooth;
}

ul{
    margin: 0px !important;
}

a {
    text-decoration: none;
    color: unset;
}

.bg-blue{
    background-color: #0A2747;
}

.border-gold {
    border: 3px solid var(--gold-color) !important;
}

.card {
    border-radius: 15px;
}

@media (min-width: 992px) {
    .w-lg-50 {
        width: 50%;
    }
}`, "",{"version":3,"sources":["webpack://./src/utils/globals.css"],"names":[],"mappings":"AAEA;IACI,6BAA6B;IAC7B,+DAA2D;AAC/D;;AAEA;IACI,qBAAqB;AACzB;;AAEA;EACE;;;;WAIS;EACT,gBAAgB;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200');\n@font-face {\n    font-family: \"Californian FB\";\n    src: url('../font/californian-fb-3.ttf') format('truetype');\n}\n\n:root {\n    --gold-color: #E9C455;\n}\n\n.material-symbols-rounded {\n  font-variation-settings:\n  'FILL' 1,\n  'wght' 400,\n  'GRAD' 200,\n  'opsz' 24;\n  font-size: 100px;\n}\n\nhtml, body {\n    margin: 0px;\n}\n\nhtml {\n    scroll-behavior: smooth;\n}\n\nul{\n    margin: 0px !important;\n}\n\na {\n    text-decoration: none;\n    color: unset;\n}\n\n.bg-blue{\n    background-color: #0A2747;\n}\n\n.border-gold {\n    border: 3px solid var(--gold-color) !important;\n}\n\n.card {\n    border-radius: 15px;\n}\n\n@media (min-width: 992px) {\n    .w-lg-50 {\n        width: 50%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
